import React, { type PropsWithChildren } from 'react';
import { Placement } from '@post-office/placements/jira-filter-refinement-filter-button';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { ChangeBoardingView } from '../../../common/types.tsx';

type Props = PropsWithChildren<{
	isEnabled?: boolean;
	changeBoardingView?: ChangeBoardingView;
}>;

export const ChangeBoarding = ({ children, isEnabled, changeBoardingView }: Props) => {
	if (
		(!isEnabled || !expVal('filter_refinement_in_tmp_backlog', 'isEnabled', false)) &&
		!changeBoardingView
	) {
		return children;
	}

	return (
		<Placement
			{...(changeBoardingView && fg('changeboarding-filter-refinement-in-nin')
				? { view: changeBoardingView }
				: {})}
		>
			{children}
		</Placement>
	);
};
